//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

export default function reducer(state, { type, payload }) {
  switch (type) {
    case 'SET_ISLOGGEDIN':
      return {
        ...state,
        isLoggedIn: payload,
      };
    case 'SET_LOADING':
      return {
        ...state,
        loading: payload,
      };
    case 'SET_USERINFO':
      return {
        ...state,
        userInfo: payload,
      };
    case 'SET_CUSTOMERACCOUNTS':
      return {
        ...state,
        customerAccounts: payload,
      };
    case "SET_LA":
      return {
        ...state,
        LA: payload,
      };
    case 'SET_ALA':
      return {
        ...state,
        ALA: payload,
      };
      case 'SET_ACA':
        return {
          ...state,
          ACA: payload,
        };
    case 'SET_BILLINGACCOUNT':
      return {
        ...state,
        billingAccount: payload,
      };
    case 'SET_ORG':
      return {
        ...state,
        org: payload,
      };
    case 'SET_SIDEBAR':
      return {
        ...state,
        sidebar: payload,
      };
    case 'SET_LOGOUT':
      return {
        isLoggedIn: false,
        loading: false,
        userInfo: {},
        customerAccounts: [],
        LA: [],
        ALA: {},
        billingAccount: {},
        sidebar: true,
        org: [],
        pathName: [],
        redirectionLinks: {},
        reportResCount: 0,
        language: [],
        selectedLanguage:''
      };
    case 'SET_PATHNAME':
      return {
        ...state,
        pathName: payload,
      };
    case 'SET_REDIRECTION_LINKS':
      return {
        ...state,
        redirectionLinks: payload,
      };
    case 'SET_REPORT_RES_COUNT':
      return {
        ...state,
        reportResCount: payload,
      };
    case 'SET_LANGUAGE':
      return {
        ...state,
        language: payload,
      };
      case 'SET_SELECTED_LANGUAGE':
      return {
        ...state,
        selectedLanguage: payload,
      };
      case 'SET_POINTS_BALANCE':
      return {
        ...state,
        pointsBalance: payload,
      };

    default:
      return state;
  }
}
